import React from "react";
import { connect } from "react-redux";
import {FormattedMessage} from "react-intl";

import Button from "@mui/material/Button";
import LockOpenIcon from "@mui/icons-material/LockOpen";

import WithOverlay from "../../../popups/withOverlayHoc";
import LookLockedOverlayAnimatedIcon from "../../animations/lookLockedOverlayAnimatedIcon";
import {setLookOverlayOpened} from "../../../../actions/lookFunctions";
import {LOOK_OVERLAYS} from "../../core/constants";
import {getFeatureIsLocked} from "../../../../misc/helpers";
import {shouldSkipLock} from "../../lookNavigation/lookMain/lookWizard/lookWizardFunctions3";


const LookLockedOverlay = (props) => {

  const {setLookOverlayOpened, lookActiveFeature, lookLockedTutorial, isMobile, wizardActiveItem, wizardActiveStep,
    wizardSelectedValues} = props;

  if (!lookActiveFeature) {
    return null
  }

  const {visible} = lookLockedTutorial;

  if (visible) {
    return null
  }

  const featureIsLocked = getFeatureIsLocked(lookActiveFeature);

  if (!featureIsLocked) {
    return null
  }

  if (shouldSkipLock({wizardActiveItem, wizardActiveStep, wizardSelectedValues})) {
    return null
  }

  const lockedButtonClick = () => {
    setLookOverlayOpened(LOOK_OVERLAYS.leadCapture);
  }

  return (
    <WithOverlay className="overlay--lottie" popupClassName="look-lottie" onClick={() => null}>
      {() => (
        <div className="look-lottie">
          <div id="lottie">
            <LookLockedOverlayAnimatedIcon/>
          </div>
          <div className="look-lottie__text bold">
            <FormattedMessage id="look.lockedOverlay.lootie.text"/>
          </div>
          <Button className={"look-button look-button--blue look-button--no-transform nowrap"
            + (isMobile ? "" : " look-button--large")}
                  startIcon={<LockOpenIcon/>}
                  onClick={lockedButtonClick}>
            <FormattedMessage id="look.lockedOverlay.lootie.button"/>
          </Button>
        </div>
      )}
    </WithOverlay>
  )
};

const mapStateToProps = (store) => {
  const {lookActiveFeature, lookLockedTutorial} = store.lookState;
  const {isMobile} = store.serverState;
  const {isPhoneNumberValidated} = store.userState; // to update component when user is logged in
  const {wizardActiveItem, wizardSelectedValues, wizardActiveStep} = store.wizardState;

  return {
    isMobile,
    lookActiveFeature,
    lookLockedTutorial,
    isPhoneNumberValidated,
    wizardActiveItem, wizardSelectedValues, wizardActiveStep,
  };
};

const mapDispatchToProps = {
  setLookOverlayOpened,
};

export default connect(mapStateToProps, mapDispatchToProps)(LookLockedOverlay)
